import { Modal } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/elements/Button';
import Card from '../../components/elements/Card';
import GridCell from '../../components/elements/GridCell';
import GuideBox from '../../components/elements/GuideBox';
import ScrollToTop from '../../components/elements/ScrollToTop';
import ChangeUserPasswordForm from '../../components/forms/ChangeUserPasswordForm';
import FilterUserForm from '../../components/forms/FilterUserForm';
import ModalUser from '../../components/fragments/ModalUser/ModalUser';
import IconActiveUser from '../../components/icons/IconActiveUser';
import IconAdd from '../../components/icons/IconAdd';
import IconBlockUser from '../../components/icons/IconBlockUser';
import IconMediation from '../../components/icons/IconMediation';
import IconPencil from '../../components/icons/IconPencil';
import IcUser from '../../components/icons/IcUser';
import { AppContext } from '../../contexts';
import { addUser, clearMessage, editUser, fetchDetailUser, fetchSearchUser, fetchSuspendUser } from './actions';
import styles from './styles.scoped.css';

export default function User() {
  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();
  const {
    search: dataSearch, detail, edit, suspend, add
  } = useSelector((state) => state.user);
  const [type, setType] = useState('');
  const [modalForm, setModalForm] = useState({
    type: 'add-user',
    isOpen: false,
  });
  const [modalChangePasswordForm, setModalChangePasswordForm] = useState(false);
  const [userData, setUserData] = useState('');

  const handleOpenModalForm = (type, user) => {
    setModalForm({ type, isOpen: true });
    if (user) setUserData(user);
  };

  const handleCloseModalForm = () => {
    setModalForm({ type: 'add-user', isOpen: false });
    setModalChangePasswordForm(false);
    handledReset();
  };

  const handleSubmit = (payload) => {
    delete payload.isActive;
    const { type } = modalForm;
    if (type === 'add-user') {
      dispatch(addUser(payload));
    }
    if (['edit-user', 'change-role'].includes(type)) {
      delete payload.isActive;
      delete payload.sam;
      delete payload.sbm;
      delete payload.userType;
      delete payload.isAdminIdaman;
      dispatch(editUser(userData.userId, payload, type));
    }
  };

  const handleSuspendUser = () => {
    dispatch(fetchSuspendUser(userData.userId));
  };

  const handleGetDetailUser = (id) => {
    dispatch(fetchDetailUser(id));
  };

  const handleSearch = (val) => {
    dispatch(fetchSearchUser(val));
  };

  const handledReset = () => {
    dispatch(clearMessage('search'));
    dispatch(clearMessage('detail'));
    dispatch(clearMessage('edit'));
    dispatch(clearMessage('suspend'));
    dispatch(clearMessage('add'));
  };

  useEffect(() => {
    handledReset();
    setBreadcrumbs(['User']);
  }, []);


  useEffect(() => {
    if (detail.data && detail.success && type) {
      handleOpenModalForm(type, detail.data);
    }
  }, [detail.data, detail.success, type]);

  useEffect(() => {
    if (edit?.success && edit?.message) {
      handleCloseModalForm();
      handledReset();
    }
  }, [edit?.success, edit?.message]);

  useEffect(() => {
    if (suspend?.success && suspend?.message) {
      handleCloseModalForm();
      handledReset();
    }
  }, [suspend?.success, suspend?.message]);

  useEffect(() => {
    if (add?.success && add?.message) {
      handleCloseModalForm();
    }
  }, [add?.success, add?.message]);

  return (
    <main className={styles.root}>
      <Card className={styles.toolBox}>
        <Button
          className={styles.button}
          onClick={() => handleOpenModalForm('add-user')}
        >
          <IconAdd style={{ fill: '#FFFFFF' }} />
          <span>Tambah User Baru</span>
        </Button>
      </Card>
      <Card className={styles.card}>
        <div className={styles.content}>
          <div>
            <img
              height="100"
              src="/assets/illu-setting-merchant.svg"
              width="100"
            />
          </div>
          <div className={styles.column}>
            <span>Cari data user</span>
            <span>Masukkan email user untuk pencarian data</span>
            <FilterUserForm
              // code={search?.code}
              handledReset={handledReset}
              handleSubmit={handleSearch}
              message={dataSearch?.message}
            />
          </div>
        </div>
        {dataSearch.data &&
          <div className={styles.contentDetail}>
            <div>
              <IcUser />
              <span className={styles.label}>{dataSearch.data.name}</span>
              <span className={[styles.badgeStatus, dataSearch.data.isActive ? styles.active : styles.inactive].join(' ')}>{dataSearch.data.isActive ? 'Aktif' : 'Diblokir'}</span>
            </div>
            <div>
              <GridCell data={dataSearch.data.email} label="Email" />
              <GridCell data={dataSearch.data.regionalName} label="Region" />
              <GridCell data={dataSearch.data.samName} label="SAM" />
              <GridCell data={dataSearch.data.sbmName} label="SBM" />
              <GridCell data={dataSearch.data.roleName} label="Role" />
            </div>
            <div className={styles.actions}>
              <Button
                onClick={() => {
                  setType('edit-user');
                  handleGetDetailUser(dataSearch.data.userId);
                }}
                title={'Edit User'}
              >
                <IconPencil style={{ fill: 'white' }} />
                <span>Perbarui Data</span>
              </Button>
              <Button
                onClick={() => {
                  handleGetDetailUser(dataSearch.data.userId);
                  setType('change-role');
                }}
                title={'Ubah Role'}
              >
                <IconMediation style={{ fill: 'white' }} />
                <span>Ubah Role</span>
              </Button>
              <Button
                onClick={() => handleOpenModalForm('block-user', dataSearch.data)}
                style={dataSearch.data?.isActive ? 'light-danger' : 'light-success'}
                title={'Blok User'}
              >
                {dataSearch.data?.isActive ?
                  <>
                    <IconBlockUser />
                    <span>Blok User</span>
                  </>
                  :
                  <>
                    <IconActiveUser />
                    <span>Aktifkan User</span>
                  </>
                }
              </Button>
            </div>
          </div>
        }
      </Card>
      <ModalUser
        data={dataSearch.data}
        error={edit?.message}
        handleSubmit={handleSubmit}
        handleSuspendUser={handleSuspendUser}
        isLoading={edit?.loading || suspend?.loading || add?.loading}
        onClose={handleCloseModalForm}
        onOpenModalChangePassword={() => {
          setModalChangePasswordForm(true);
          setModalForm({ type: 'change-password', isOpen: false });
        }}
        open={modalForm.isOpen}
        type={modalForm.type}
        values={userData}
      />
      <Modal
        centered
        onClose={handleCloseModalForm}
        opened={modalChangePasswordForm}
        size={'lg'}
      >
        <div className={styles.modalContent}>
          <h4>Form Ubah Password</h4>
          <GuideBox>
            <p>
              Berikut adalah form yang digunakan untuk merubah{' '}
              <strong>Password</strong> user. Pastikan password yang dimasukkan
              sudah sesuai.
            </p>
          </GuideBox>
          <ChangeUserPasswordForm handleSubmit={handleSubmit} />
        </div>
      </Modal>
      <ScrollToTop />
    </main>
  );
}
